// extracted by mini-css-extract-plugin
export default {"plotInputContainer":"PlotInput_plotInputContainer__LRp-J","icon":"PlotInput_icon__Yj50I","plotInput":"PlotInput_plotInput__DPbDe"};